import { Text } from '@chakra-ui/react'

export default function FormInputRequiredStar(): React.ReactElement {
  return (
    <Text as="span" ml="2px" fontSize="20px" color="fg.error">
      *
    </Text>
  )
}
